module.exports = __webpack_public_path__ + "static/img/KH.f87450c7.jpg";